import { Routes, Route } from 'react-router-dom'

import RootLayout from './layouts/RootLayout'
import AuthLayout from './layouts/AuthLayout'
import CatalogueLayout from './layouts/CatalogueLayout'
import DashboardLayout from './layouts/DashboardLayout'
import ProviderLayout from './layouts/ProviderLayout'
import CentreFormationLayout from './layouts/CentreFormationLayout'
import AdminLayout from './layouts/AdminLayout'

import Home from './pages/Home'
import Cgv from './pages/Cgv'
import MentionsLegales from './pages/MentionsLegales'
import Confidentialite from './pages/Confidentialite'
import Experts from './pages/Experts'
import ConsultationChat from './pages/ConsultationChat'
import NotFound from './pages/NotFound'

import CatalogueList from './pages/catalogue/CatalogueList'
import CatalogueDetail from './pages/catalogue/CatalogueDetail'

import Connexion from './pages/auth/Connexion'
import Inscription from './pages/auth/Inscription'
import InscriptionEntreprise from './pages/auth/InscriptionEntreprise'
import InscriptionCentreFormation from './pages/auth/InscriptionCentreFormation'
import InscriptionPrestataire from './pages/auth/InscriptionPrestataire'

import Dashboard from './pages/dashboard/Dashboard'
import Missions from './pages/dashboard/Missions'
import MissionNouvelle from './pages/dashboard/MissionNouvelle'
import MissionDetail from './pages/dashboard/MissionDetail'
import Documents from './pages/dashboard/Documents'
import Formations from './pages/dashboard/Formations'
import GuideEntreprise from './pages/dashboard/GuideEntreprise'
import Analytics from './pages/dashboard/Analytics'
import Parametres from './pages/dashboard/Parametres'
import CentreDeFormationList from './pages/dashboard/CentreDeFormationList'
import CentreDeFormationDetail from './pages/dashboard/CentreDeFormationDetail'
import CentreDeFormationQualiopi from './pages/dashboard/CentreDeFormationQualiopi'

import Disponibilites from './pages/provider/Disponibilites'
import Guide from './pages/provider/Guide'
import MesMissions from './pages/provider/MesMissions'
import MissionsDisponibles from './pages/provider/MissionsDisponibles'
import MissionDisponibleDetail from './pages/provider/MissionDisponibleDetail'
import ProfilPrestataire from './pages/provider/ProfilPrestataire'
import Qualifications from './pages/provider/Qualifications'

import CfDashboard from './pages/centre-formation/CfDashboard'
import CfDocuments from './pages/centre-formation/CfDocuments'
import CfFormations from './pages/centre-formation/CfFormations'
import CfGuide from './pages/centre-formation/CfGuide'
import CfMesMissions from './pages/centre-formation/CfMesMissions'
import CfParametres from './pages/centre-formation/CfParametres'
import MesFormations from './pages/centre-formation/MesFormations'
import Qualiopi from './pages/centre-formation/Qualiopi'
import Sessions from './pages/centre-formation/Sessions'
import SessionDetail from './pages/centre-formation/SessionDetail'

import AdminOverview from './pages/admin/AdminOverview'
import AdminBaseDeDonnees from './pages/admin/AdminBaseDeDonnees'
import AdminGuide from './pages/admin/AdminGuide'
import AdminLogs from './pages/admin/AdminLogs'
import AdminMissions from './pages/admin/AdminMissions'
import AdminParametres from './pages/admin/AdminParametres'
import AdminStats from './pages/admin/AdminStats'
import AdminTypesMissions from './pages/admin/AdminTypesMissions'
import AdminUtilisateurs from './pages/admin/AdminUtilisateurs'

export default function App() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/cgv" element={<Cgv />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/consultations/:id" element={<ConsultationChat />} />

        <Route element={<CatalogueLayout />}>
          <Route path="/catalogue" element={<CatalogueList />} />
          <Route path="/catalogue/:id" element={<CatalogueDetail />} />
          <Route path="/experts" element={<Experts />} />
        </Route>

        <Route element={<AuthLayout />}>
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/inscription/entreprise" element={<InscriptionEntreprise />} />
          <Route path="/inscription/centre-de-formation" element={<InscriptionCentreFormation />} />
          <Route path="/inscription/prestataire" element={<InscriptionPrestataire />} />
        </Route>

        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/missions" element={<Missions />} />
          <Route path="/missions/nouvelle" element={<MissionNouvelle />} />
          <Route path="/missions/:id" element={<MissionDetail />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/formations" element={<Formations />} />
          <Route path="/guide-entreprise" element={<GuideEntreprise />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/parametres" element={<Parametres />} />
          <Route path="/centre-de-formation" element={<CentreDeFormationList />} />
          <Route path="/centre-de-formation/qualiopi" element={<CentreDeFormationQualiopi />} />
          <Route path="/centre-de-formation/:id" element={<CentreDeFormationDetail />} />
        </Route>

        <Route element={<ProviderLayout />}>
          <Route path="/disponibilites" element={<Disponibilites />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/mes-missions" element={<MesMissions />} />
          <Route path="/missions-disponibles" element={<MissionsDisponibles />} />
          <Route path="/missions-disponibles/:id" element={<MissionDisponibleDetail />} />
          <Route path="/profil-prestataire" element={<ProfilPrestataire />} />
          <Route path="/qualifications" element={<Qualifications />} />
        </Route>

        <Route element={<CentreFormationLayout />}>
          <Route path="/cf-dashboard" element={<CfDashboard />} />
          <Route path="/cf-documents" element={<CfDocuments />} />
          <Route path="/cf-formations" element={<CfFormations />} />
          <Route path="/cf-guide" element={<CfGuide />} />
          <Route path="/cf-mes-missions" element={<CfMesMissions />} />
          <Route path="/cf-parametres" element={<CfParametres />} />
          <Route path="/mes-formations" element={<MesFormations />} />
          <Route path="/qualiopi" element={<Qualiopi />} />
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/sessions/:id" element={<SessionDetail />} />
        </Route>

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="base-de-donnees" element={<AdminBaseDeDonnees />} />
          <Route path="guide" element={<AdminGuide />} />
          <Route path="logs" element={<AdminLogs />} />
          <Route path="missions" element={<AdminMissions />} />
          <Route path="parametres" element={<AdminParametres />} />
          <Route path="stats" element={<AdminStats />} />
          <Route path="types-missions" element={<AdminTypesMissions />} />
          <Route path="utilisateurs" element={<AdminUtilisateurs />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
